export var SLICE = "lps";
// getUserProfileInfo action types.
var GET_AUTHORIZED_LPS = "".concat(SLICE, "/GET_AUTHORIZED_LPS");
export var GET_AUTHORIZED_LPS_REQUEST = "".concat(GET_AUTHORIZED_LPS, "_REQUEST");
export var GET_AUTHORIZED_LPS_SUCCESS = "".concat(GET_AUTHORIZED_LPS, "_SUCCESS");
export var GET_AUTHORIZED_LPS_FAILURE = "".concat(GET_AUTHORIZED_LPS, "_FAILURE");
// getSelectedLp action types.
var GET_AUTHORIZED_LP_SELECTED = "".concat(SLICE, "/GET_AUTHORIZED_LP_SELECTED");
export var GET_AUTHORIZED_LP_SELECTED_REQUEST = "".concat(GET_AUTHORIZED_LP_SELECTED, "_REQUEST");
export var GET_AUTHORIZED_LP_SELECTED_SUCCESS = "".concat(GET_AUTHORIZED_LP_SELECTED, "_SUCCESS");
export var GET_AUTHORIZED_LP_SELECTED_FAILURE = "".concat(GET_AUTHORIZED_LP_SELECTED, "_FAILURE");
// getAuthorizedEntities action types.
var GET_AUTHORIZED_ENTITIES = "".concat(SLICE, "/GET_AUTHORIZED_ENTITIES");
export var GET_AUTHORIZED_ENTITIES_REQUEST = "".concat(GET_AUTHORIZED_ENTITIES, "_REQUEST");
export var GET_AUTHORIZED_ENTITIES_SUCCESS = "".concat(GET_AUTHORIZED_ENTITIES, "_SUCCESS");
export var GET_AUTHORIZED_ENTITIES_FAILURE = "".concat(GET_AUTHORIZED_ENTITIES, "_FAILURE");
// setLPPickerInput action type.
export var SET_LP_PICKER_INPUT = "".concat(SLICE, "/SET_LP_PICKER_INPUT");

//# sourceMappingURL=actionTypes.js.map